// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-card {
  width: 183.2px;
  flex-shrink: 0;
}

.lotus-casino-card--compact {
  width: auto;
  max-width: 100%;
  min-width: 0;
  flex-shrink: 1;
}

.lotus-casino-card--compact .lotus-casino-card__banner {
  aspect-ratio: 245 / 153;
  height: auto;
}

.lotus-casino-card__container {
  position: relative;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.lotus-casino-card__banner {
  width: 100%;
  height: 115px;
  background: #1a1a1a;
  overflow: hidden;
}

.lotus-casino-card__banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.lotus-casino-card__banner-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
}

.lotus-casino-card__favorite {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 11;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #ffffff;
  font-size: 24px;
  line-height: 1;
  opacity: 1;
  transition: color 0.15s ease;
}

.lotus-casino-card__favorite.selected {
  color: #f5ab00;
}

.lotus-casino-card__container:hover .lotus-casino-card__favorite {
  color: #ffffff;
}

.lotus-casino-card__actions {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  background: rgba(8, 8, 8, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.lotus-casino-card__container:hover .lotus-casino-card__actions {
  opacity: 1;
  pointer-events: auto;
}

.lotus-casino-card__play {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 103px;
  height: 36px;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  background: #2c4f58;
  color: #ffffff;
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.lotus-casino-card__play:hover {
  background: #2c4f58;
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoGameCard/LotusCasinoGameCard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".lotus-casino-card {\n  width: 183.2px;\n  flex-shrink: 0;\n}\n\n.lotus-casino-card--compact {\n  width: auto;\n  max-width: 100%;\n  min-width: 0;\n  flex-shrink: 1;\n}\n\n.lotus-casino-card--compact .lotus-casino-card__banner {\n  aspect-ratio: 245 / 153;\n  height: auto;\n}\n\n.lotus-casino-card__container {\n  position: relative;\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.lotus-casino-card__banner {\n  width: 100%;\n  height: 115px;\n  background: #1a1a1a;\n  overflow: hidden;\n}\n\n.lotus-casino-card__banner img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.lotus-casino-card__banner-placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);\n}\n\n.lotus-casino-card__favorite {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 11;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: #ffffff;\n  font-size: 24px;\n  line-height: 1;\n  opacity: 1;\n  transition: color 0.15s ease;\n}\n\n.lotus-casino-card__favorite.selected {\n  color: #f5ab00;\n}\n\n.lotus-casino-card__container:hover .lotus-casino-card__favorite {\n  color: #ffffff;\n}\n\n.lotus-casino-card__actions {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  background: rgba(8, 8, 8, 0.6);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  border-radius: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  pointer-events: none;\n}\n\n.lotus-casino-card__container:hover .lotus-casino-card__actions {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.lotus-casino-card__play {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-width: 103px;\n  height: 36px;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 8px;\n  background: #2c4f58;\n  color: #ffffff;\n  font-family: \"Lato\", sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.lotus-casino-card__play:hover {\n  background: #2c4f58;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
